import EthereumService from '@/services/ethereum'
import cookie from '@/utils/cookie'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async updateUserData (options = {}) {
    try {
      if (
        options.initial &&
        this.store &&
        this.store.state &&
        this.store.state.user &&
        this.store.state.user.id
      ) {
        return this.store.state.user
      } else if (cookie.get('accessToken') && cookie.get('user')) {
        const { data } = await this.kulapApi.getUserProfile()
        this.store.dispatch('setUser', data)
        return data
      } else {
        this.store.dispatch('setUser', {})
      }
    } catch (e) {
      this.logout()
    }
  }

  logout () {
    this.kulapApi.postLogout()
    cookie.remove('accessToken')
    cookie.remove('user')
    this.updateUserData()
  }
}



// WEBPACK FOOTER //
// ./src/features/Header/service.js